"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderInto = void 0;
var client_1 = require("react-dom/client");
var KEY = '__msiaReactRoots__';
function getRoots() {
    var w = window;
    if (!w[KEY])
        w[KEY] = new Map();
    return w[KEY];
}
/**
 * Render the given node into the DOM element, reusing the React root cached
 * for that element on repeated calls. Theme-agnostic — most callers should
 * prefer {@link ./mountIsland.mountIsland}, which wraps the children in the
 * shared MUI ThemeProvider. Use this primitive directly only when the
 * rendered tree manages its own ThemeProvider (or doesn't need one).
 */
function renderInto(el, node) {
    var roots = getRoots();
    var root = roots.get(el);
    if (!root) {
        root = (0, client_1.createRoot)(el);
        roots.set(el, root);
    }
    root.render(node);
}
exports.renderInto = renderInto;
